import React from 'react';
import {
    FilterItemDiv,
    FilterAccountNameDiv,
    FilterAccountNumberDiv,
    FilterFavouriteIconDiv,
} from './FilterAccountLabel.styled';
import Star from 'src/assets/images/Star.svg';
import { useTranslation } from 'react-i18next';

const FilterAccountLabel = ({
    name,
    accountId,
    isFavourite, //isFavourite will be shown if showFavourite is true and based on isFavourite true start will be shown
    showFavourite, //Show Favourite div in Account Label
}) => {
    const { t } = useTranslation();
    return (
        <>
            <FilterItemDiv gridTemplateColumns={!showFavourite && 'auto 25%'}>
                <FilterAccountNameDiv>
                    {name === 'All' ? t('common.allLabel') : name} &nbsp;
                </FilterAccountNameDiv>
                <FilterAccountNumberDiv
                    gridColumns={!showFavourite && '2/-1'}
                    style={{}}
                >
                    {accountId &&
                    accountId !== 'accountIdAll' &&
                    accountId !== 'favACC' //value:favouriteAccounts,key:favACC is constant from API, we should not show the key of favouriteAccounts to the user.
                        ? parseInt(accountId)
                            ? parseInt(accountId)
                            : accountId
                        : null}
                </FilterAccountNumberDiv>
                <FilterFavouriteIconDiv
                    display={!showFavourite ? 'none' : undefined}
                    style={{}}
                >
                    {isFavourite && (
                        <img
                            src={Star}
                            alt="Favourite"
                            style={{
                                width: '16px',
                                height: '16px',
                            }}
                        />
                    )}
                </FilterFavouriteIconDiv>
            </FilterItemDiv>
        </>
    );
};

export default FilterAccountLabel;
